import { render, staticRenderFns } from "./DeleteRenderer.vue?vue&type=template&id=2d74a62c"
import script from "./DeleteRenderer.vue?vue&type=script&lang=js"
export * from "./DeleteRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports